import React from 'react'
import Layout from '../../components/Layout'
export default function GroupManagement() {
  return (
    <Layout>
    <div>GroupManagement</div>
    </Layout>
  )
}
